import { defineNuxtPlugin, useUserStore } from '#imports'
import { watch } from 'vue'

import { updateUserContext } from '../utils/tracking/updateUserContext'

export default defineNuxtPlugin(() => {
  const { isUserFetched } = useUserStore()

  // If the user was fetched server-side, update the user context immediately
  // If the user is fetched client-side, wait for it to be fetched to update the user context
  watch(
    isUserFetched,
    () => {
      if (isUserFetched.value) {
        updateUserContext()
      }
    },
    { immediate: true },
  )
})
